
import { apiFetch } from './index.js';

/**
 * Obtener todas las salidas de equipo
 */
export const obtenerSalidasEquipo = async () => {
    try {
        const response = await apiFetch('/SalidaEquipoDetalle');
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Crear una nueva salida de equipo
 * @param {Object} data - Datos de la salida (CreateSalidaEquipoDetalleDTO)
 */
export const crearSalidaEquipo = async (data) => {
    try {
        const response = await apiFetch('/SalidaEquipoDetalle', {
            method: 'POST',
            body: data
        });
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Obtener salidas por detalle de recepción
 * @param {number} idRecepcionDetalle 
 */
export const obtenerSalidasPorRecepcionDetalle = async (idRecepcionDetalle) => {
    try {
        const response = await apiFetch(`/SalidaEquipoDetalle/recepcion-detalle/${idRecepcionDetalle}`);
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message };
    }
};
